import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { FavoritesProvider } from './context/FavoritesContext';
import { AuthProvider } from './context/authContext';
import i18n from './languages/i18n';
import { CookiesProvider } from 'react-cookie';
// import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));

// Controllo se il Service Worker è supportato
if ('serviceWorker' in navigator) {
  // Provo a registrare il Service Worker
  navigator.serviceWorker.register('/sw.js')
    .then(registration => {
      // Controllo se il Service Worker è pronto, se supportato
      return navigator.serviceWorker.ready;
    })
    .then(() => {
    })
    .catch(error => {
      // In caso di errore nella registrazione o disponibilità, logga l'errore ma non interrompere l'app
    });
} else {
}

root.render(
  <React.StrictMode>
    <CookiesProvider>
      <AuthProvider>
        <FavoritesProvider>
          <App />
        </FavoritesProvider>
      </AuthProvider>
    </CookiesProvider>
  </React.StrictMode>
);

// Web Vitals reporting - Completamente disabilitato per evitare log in console
// if (process.env.NODE_ENV === 'production') {
//   reportWebVitals((metric) => {
//     // Invia a Google Analytics se disponibile
//     if (typeof window.gtag !== 'undefined') {
//       window.gtag('event', metric.name, {
//         value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
//         event_category: 'Web Vitals',
//         event_label: metric.id,
//         non_interaction: true,
//       });
//     }
//   });
// }
